import { render, staticRenderFns } from "./addEditOrgs.vue?vue&type=template&id=060022c1&scoped=true"
import script from "./addEditOrgs.vue?vue&type=script&lang=js"
export * from "./addEditOrgs.vue?vue&type=script&lang=js"
import style0 from "./addEditOrgs.vue?vue&type=style&index=0&id=060022c1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060022c1",
  null
  
)

export default component.exports